export const MISSION_TYPES = {
  PLAY_ALL_GAMES: "play_all_games",
  DAILY_PLAY_STREAK: "daily_play_streak",
  HANGMAN_WIN_STREAK: "hangman_win_streak",
  MANUAL_CONTENT: "manual_content",
};

export const MISSION_TYPE_OPTIONS = [
  { value: MISSION_TYPES.MANUAL_CONTENT, label: "Content only" },
  { value: MISSION_TYPES.PLAY_ALL_GAMES, label: "Play all games" },
  { value: MISSION_TYPES.DAILY_PLAY_STREAK, label: "Daily play streak" },
  { value: MISSION_TYPES.HANGMAN_WIN_STREAK, label: "Hangman win streak" },
];

export const ALL_GAME_IDS = [
  "hangman",
  "filler",
  "flashcards",
  "dino",
  "maze",
  "opsTickles",
];

export const MISSION_SLOT_COUNT = 30;

export const SEED_MISSIONS = {
  1: {
    title: "Play all six games",
    text: "Play Hangman, Filler, Flashcards, Dino Run, Maze, and Ops-tickles at least once. Mega reward when you finish the set!",
    imageUrl: "",
    type: MISSION_TYPES.PLAY_ALL_GAMES,
    rewardPoints: 150,
    config: { target: 6 },
    active: true,
  },
  2: {
    title: "Play every day",
    text: "Come back and play any game each day. Keep a 7-day streak for a mega star bonus!",
    imageUrl: "",
    type: MISSION_TYPES.DAILY_PLAY_STREAK,
    rewardPoints: 200,
    config: { target: 7 },
    active: true,
  },
  3: {
    title: "Hangman master streak",
    text: "Win 25 Hangman words in a row without losing. One wrong word resets the streak!",
    imageUrl: "",
    type: MISSION_TYPES.HANGMAN_WIN_STREAK,
    rewardPoints: 300,
    config: { target: 25 },
    active: true,
  },
};

export const createEmptyMission = (slot) => {
  const seed = SEED_MISSIONS[slot];
  if (seed) {
    return {
      id: `mission_${String(slot).padStart(2, "0")}`,
      slot,
      ...seed,
    };
  }

  return {
    id: `mission_${String(slot).padStart(2, "0")}`,
    slot,
    title: "",
    text: "",
    imageUrl: "",
    type: MISSION_TYPES.MANUAL_CONTENT,
    rewardPoints: 0,
    config: { target: 1 },
    active: true,
  };
};

export const isMissionFilled = (mission) =>
  Boolean(
    (mission?.title && mission.title.trim()) ||
      (mission?.text && mission.text.trim()) ||
      (mission?.imageUrl && mission.imageUrl.trim()) ||
      (mission?.type &&
        mission.type !== MISSION_TYPES.MANUAL_CONTENT &&
        Number(mission?.rewardPoints) > 0)
  );

export const createDefaultGameProgress = () => ({
  gamesPlayed: {
    hangman: 0,
    filler: 0,
    flashcards: 0,
    dino: 0,
    maze: 0,
    opsTickles: 0,
  },
  uniqueGamesPlayed: [],
  lastPlayDate: null,
  playDates: [],
  dayStreak: 0,
  hangmanWinStreak: 0,
  hangmanBestWinStreak: 0,
});
